<template>
    <div>
        <div class="back" v-if="isVisible" @click="hideModal"></div>
        <div class="serviceView" v-if="isVisible">
            <div class="modalView_pop">
                <div class="modalView_pop_l">
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <div class="modalView_pop_l_view_t_3_text">{{ $t('authCodeList.title') }}</div>
                            </div>
                            <div class="modalView_pop_l_view_t_2">{{ $t('authCodeList.desc') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_r_2_choose">
                                    <div class="modalView_pop_r_2_choose_btn" @click="showCodeDialog">{{ $t('authCodeList.addCode') }}</div>
                                </div>
                            </div>
                            <div class="modalView_pop_l_view_b_table">
                                <el-table
                                    :data="tableData"
                                    height="100%"
                                    border
                                    v-loading="loading"
                                    style="width: 100%"
                                    :row-style="rowStyle"
                                    @row-click="handleRowClick"
                                >
                                    <el-table-column
                                        prop="id"
                                        :label= "$t('authCodeList.number')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.number'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.$index + 1 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="code"
                                        :label="$t('authCodeList.code')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.code'))"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="permission_id"
                                        :label="$t('serviceI18n.service_id')"
                                        align="center"
                                        class-name="wrap-header"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="reseller"
                                        :label="$t('authCodeList.channel')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.channel'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.reseller?.reseller_name || '' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="reseller_order_id"
                                        :label="$t('authCodeList.channelOrderId')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.channelOrderId'))"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="package_spec"
                                        :label="$t('authCodeList.package_spec')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.package_spec'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.service_package?.package_spec || '' }}
                                        </template> 
                                    </el-table-column>
                                    <el-table-column
                                        prop="license_payload"
                                        :label="$t('authCodeList.product')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.product'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getProduct(scope.row.license_payload?.feature_code) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="scope"
                                        :label="$t('authCodeList.scope')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.scope'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getScopeName(scope.row.license_payload?.scope) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="address_limit"
                                        :label="$t('authCodeList.address_limit')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.address_limit'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getAddressLimit(scope.row.license_payload?.address_limit) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="source_limit"
                                        :label="$t('authCodeList.source_limit')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.source_limit'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getSourceLimit(scope.row.license_payload?.source_limit) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="status"
                                        :label="$t('authCodeList.status')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.status'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getStatusName(scope.row.status) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="activated_at"
                                        :label="$t('authCodeList.activatedAt')"
                                        align="center"
                                        :class-name="getHeaderClass($t('authCodeList.activatedAt'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.activated_at ? $dayjs(scope.row.activated_at).format('YYYY-MM-DD HH:mm:ss') : '' }}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column
                                        :label="$t('authCodeList.action')"
                                        align="center"
                                        width="140"
                                        :class-name="getHeaderClass($t('authCodeList.action'))"
                                    >
                                        <template slot-scope="scope">
                                            <div class="tableBtnView">
                                                <el-button @click="handleView(scope.row)" type="text" size="small">{{$t('authCodeList.view')}}</el-button>
                                                <el-button @click="handleDelete(scope.row)" type="text" size="small" v-if="scope.row.status !== 1">{{ $t('authCodeList.delete') }}</el-button>
                                            </div>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </div>
                            <div class="modalView_pop_l_view_b_page">
                                <el-pagination
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="25"
                                    layout="prev, pager, next"
                                    :total="totalNum">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 激活、添加授权码弹窗 -->
        <CodeDialog ref="codeDialog" @activated="handleActivated"/>
    </div>
</template>

<script>
import { getAuthCodeList, deleteAuthCode, getFeatures } from '@/api/index';
import CodeDialog from './CodeDialog.vue';
import { mapState } from "vuex";
export default {
    components: {
        CodeDialog
    },
    data() {
        return {
            isVisible: false, // 控制弹窗的显示状态
            currentRowId: null, // 当前点击的行ID
            tableData: [],
            totalNum: 0,
            currentPage: 1,
            loading: false,
            detailVisible: false,
            currentAuthCode: {},
            featuresMap: {},
        }
    },
    methods: {
        // 表头判断
        getHeaderClass(label) {
            // 判断内容是否包含英文
            const hasEnglish = /[a-zA-Z]/.test(label);
            return hasEnglish ? 'no-wrap-header' : 'wrap-header';
        },

        // 获取状态名称
        getStatusName(status) {
            switch (status) {
                case "activated":
                    return this.$t('authCode.activated');
                default:
                return '';
            }
        },

        // 获取产品名称
        getProduct(feature_code) {
            return this.featuresMap[feature_code] || '';
        },

        // 获取范围名称
        getScopeName(scope) {
            switch (scope) {
                case 0:
                    return this.$t('orderI18n.scope_list[0].name');
                case 1:
                    return this.$t('orderI18n.scope_list[1].name');
                default:
                return '';
            }
        },

        // 获取地址限制
        getAddressLimit(address_limit) {
            switch (address_limit) {
                case 2:
                    return "≤2";
                case 4:
                    return "≤4";
                case 30:
                    return "≤30";
                default:
                return address_limit;
            }
        },

        // 获取数据源限制
        getSourceLimit(source_limit) {
            switch (source_limit) {
                case 0:
                    return "≤100";
                case 1:
                    return "≤500";
                case 2:
                    return ">500";
                case 10:
                    return "≤20";
                default:
                return '';
            }
        },

        showModal() {
            this.isVisible = true; // 控制弹窗的显示状态
            document.body.style.overflow = 'hidden'; // 禁止页面滚动
            this.loadList();
        },

        hideModal() {
            this.isVisible = false; // 控制弹窗的显示状态
            document.body.style.overflow = ''; // 恢复页面滚动  
            this.currentRowId = null;
        },

        // 获取授权码列表
        async loadList() {
            try {
                const productRes = await getFeatures();
                if (productRes.data.data.length > 0) {
                    productRes.data.data.forEach(item => {
                        this.featuresMap[item.code] = item.title;
                    });
                }
                
                // 然后加载授权码列表
                const res = await getAuthCodeList({
                    page: this.currentPage,
                    limit: 100
                });
                
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                    this.totalNum = res.data.data.length;
                } else {
                    this.$message.error(res.data.msg || this.$t('authCodeList.message.load_error'));
                    this.hideModal();
                }
            } catch (error) {
                this.$message.error(error || this.$t('authCodeList.message.load_error'));
                this.hideModal();
            } finally {
                this.loading = false;
            }
        },

        // 当前页处理
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadList();
        },

        // 处理查看
        handleView(row) {
            this.currentAuthCode = { ...row };
            this.detailVisible = true;
        },

        //激活、添加授权码
        showCodeDialog() {
            this.$refs.codeDialog.showModal();
        },

        //授权码激活成功回调
        handleActivated() {
            this.loadList();
            this.$emit('activated');
        },

        // 处理删除
        handleDelete(row) {
            this.$confirm(this.$t('authCodeList.message.delete_confirm'), this.$t('authCodeList.tips'), {
                confirmButtonText: this.$t('authCodeList.confirmBtn'),
                cancelButtonText: this.$t('authCodeList.cancelBtn'),
                type: 'warning'
            }).then(() => {
                deleteAuthCode(row.id).then((res) => {
                    if (res.data.code === 200) {
                        this.$message.success(this.$t('authCodeList.message.delete_success'));
                        this.loadList();
                    } else {
                        this.$message.error(res.data.msg || this.$t('authCodeList.message.delete_fail'));
                    }
                }).catch((error) => {
                    this.$message.error(error || this.$t('authCodeList.message.delete_fail'));
                });
            });
        },

        // 处理行点击事件
        handleRowClick(row) {
            this.currentRowId = row.id; // 更新当前点击的行ID
        },

        // 行样式
        rowStyle({ row }) {
            if (this.currentRowId === row.id) {
                return { 'background': ' linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%)', 'color': '#000', 'font-weight': '700' }; // 返回选中行的样式
            }
            return {};
        },
    },
    computed: {
        ...mapState(["userInfo"]),
    },
};
</script>

<style scoped lang="scss">
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.serviceView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    width: 1200px;
    height: 650px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;

    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        background-color: #ffffff; /* 设置不透明的白色底色 */
        background-image: var(--global-inner-background); /* 渐变叠加在白色底色上 */
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            width: 1100px;
            height: 100%;
            position: relative;

            .modalView_pop_l_view {
                width: 100%;
                height: 100%;
                margin: 0 10px 0 35px;
                border-left: 2px dashed #E3E6E8;
                border-right: 2px dashed #E3E6E8;
                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    

                    .modalView_pop_l_view_t_1 {
                        width: auto;
                        height: 46px;
                        margin-left: 33px;                   

                        .modalView_pop_l_view_t_3_text{
                            font-size: 35px;
                            color: rgba(33, 33, 33, 1);
                            font-weight: 500;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        letter-spacing: 3px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 160px);
                    position: relative;

                    .modalView_pop_l_view_b_2{
                        margin:20px 10px 30px 33px;
                        height: auto;
                        overflow-y: hidden; 

                        .modalView_pop_r_2_choose{
                          height: 40px;
                          width: 100%;
                          display: flex;
                          align-items: center;

                            .modalView_pop_r_2_choose_btn{
                                height: 40px;
                                width: max-content;
                                padding: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                                background: var(--global-primary);
                                color: #fff;
                                font-size: 18px;
                                font-weight: 500;
                                border-radius: 15px;
                                cursor: pointer;
                            }
                        }
                    }

                    .modalView_pop_l_view_b_table{
                        margin: 0 33px auto;
                        overflow-y: auto; /* 启用垂直滚动条 */
                        padding-right: 10px; /* 为滚动条预留空间，避免内容被遮挡 */
                        scrollbar-width: thin; /* 优化滚动条宽度（Firefox） */
                        scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
                        height: calc(100% - 100px);
                        

                        ::v-deep .el-table, 
                        ::v-deep .el-table__expanded-cell {
                            background-color: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        ::v-deep .no-wrap-header .cell{
                            word-break: keep-all;
                        }

                        ::v-deep .wrap-header .cell{
                            white-space: normal; 
                        }

                        ::v-deep .el-table--border{
                            background-color: transparent!important;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                            border: 1px solid rgba(58, 83, 36, 0.75)!important;
                        }

                        /* 表格内背景颜色 */
                        ::v-deep .el-table th,
                        ::v-deep .el-table tr,
                        ::v-deep .el-table td {
                            background: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        /* 设置点击行的渐变色背景 */
                        ::v-deep .el-table__body tr.current-row > td {
                            background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%) !important;
                            color: #000 !important; /* 设置文字颜色为黑色 */
                            font-weight: 700 !important;
                        }

                        .tableBtnView{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
                            margin: 0;
                        }
                    }

                    .modalView_pop_l_view_b_page{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }
                }
            }
        }
    }
}

.dialog-content-authcode{
    text-align: left;
    .detail-form {
        .el-form-item {
            margin-bottom: 15px;
        }
        .features-list {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            padding: 8px 0;
        }
        .feature-tag {
            background-color: #f0f0f0;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 14px;
        }
    }
}

/* 如果使用scoped，可能需要调整选择器，例如使用深度选择器 >>> */
*[innerHTML*="<br>"] {
    display: inline-block;
    text-indent: 0;
}
*[innerHTML*="<br>"] br + * {
    display: block;
    text-indent: 2em;
}
</style>